import { render } from "./INPUT_FORM.vue?vue&type=template&id=2de792c8&scoped=true"
import script from "./INPUT_FORM.vue?vue&type=script&lang=js"
export * from "./INPUT_FORM.vue?vue&type=script&lang=js"

import "./INPUT_FORM.vue?vue&type=style&index=0&id=2de792c8&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de792c8"]])

export default __exports__